import { Link } from "react-router-dom";
import { useSettings, useServices } from "@/hooks/useData";
import { servicePath } from "@/lib/content";
import { Reveal } from "@/components/motion/Reveal";

const Col = ({ title, children }) => (
  <div>
    <p className="label text-paper/40 mb-6">{title}</p>
    <ul className="flex flex-col gap-3">{children}</ul>
  </div>
);
const L = ({ to, children, testid }) => (
  <li>
    <Link to={to} data-testid={testid} className="link-line text-sm text-paper/80 hover:text-paper transition-colors">{children}</Link>
  </li>
);

export function Footer() {
  const s = useSettings();
  const { data: services = [] } = useServices();
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-paper grain">
      <div className="container-x relative z-10 pt-24 pb-28 md:pb-16">
        <Reveal>
          <img src="/logo-white.png" alt="Emini Reinigung" className="h-10 md:h-14 w-auto" />
        </Reveal>
        <div className="hairline-dark my-14" />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-10 md:gap-8">
          <Col title="Leistungen">
            {services.map((sv) => (
              <L key={sv.slug} to={servicePath(sv.slug)}>{sv.name}</L>
            ))}
          </Col>
          <Col title="Unternehmen">
            <L to="/privatreinigung">Privatkunden</L>
            <L to="/geschaeftskunden">Geschäftskunden</L>
            <L to="/ueber-uns">Über uns</L>
            <L to="/kontakt" testid="footer-link-kontakt">Kontakt</L>
          </Col>
          <Col title="Kontakt">
            <li><a href={`tel:${s?.phone_link}`} data-testid="footer-phone" className="link-line text-sm text-paper/80 hover:text-paper">{s?.phone}</a></li>
            <li><a href={`mailto:${s?.email}`} data-testid="footer-email" className="link-line text-sm text-paper/80 hover:text-paper">{s?.email}</a></li>
            <li className="text-sm text-paper/60 leading-relaxed pt-2">
              {s?.company}<br />{s?.address_line1}<br />{s?.address_line2}
            </li>
            {s?.instagram && (
              <li><a href={s.instagram} target="_blank" rel="noreferrer" className="link-line text-sm text-paper/80">Instagram</a></li>
            )}
          </Col>
        </div>
        <div className="hairline-dark my-14" />
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <p className="label text-paper/80">Sauber. Zuverlässig. Emini.</p>
          <div className="flex gap-8 label text-paper/40">
            <Link to="/impressum" data-testid="footer-link-impressum" className="link-line hover:text-paper">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="link-line hover:text-paper">Datenschutz</Link>
            <span>© {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
